module.exports = __webpack_public_path__ + "static/media/Logo_UNI-AFYA_branca2.ec8ea620.png";